var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 6,
    fill: "#0DD1C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.127 16.583a.821.821 0 01-.538-.215l-3.763-3.87a.844.844 0 010-1.183.844.844 0 011.183 0l3.118 3.225 6.56-6.881a.844.844 0 011.182 0 .844.844 0 010 1.182l-7.097 7.527c-.215.108-.43.215-.645.215z",
    fill: "#fff"
  })));
}
export default SvgPolicyCheckboxChecked;